const FETCH_TESTIMONIALS = "testimonial/FETCH_TESTIMONIALS";
const FETCH_TESTIMONIALS_SUCCESS = "testimonial/FETCH_TESTIMONIALS_SUCCESS";
const FETCH_TESTIMONIALS_FAIL = "testimonial/FETCH_TESTIMONIALS_FAIL";


const initialState = {
  pending: true,
  loaded: false,
  testimonials: {},
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_TESTIMONIALS:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_TESTIMONIALS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        testimonials: { ...action.results },
        error: null
      });
    case FETCH_TESTIMONIALS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        error: action.error
      });

    default:
      return state;
  }
}

export function fetchTestimonialsPending() {
  return {
    type: FETCH_TESTIMONIALS
  };
}

export function fetchTestimonialsSuccess(results) {
  return {
    type: FETCH_TESTIMONIALS_SUCCESS,
    results
  };
}

export function fetchTestimonialsFail(error) {
  return {
    type: FETCH_TESTIMONIALS_FAIL,
    error
  };
}

export const getTestimonials = state => state.testimonials;
export const getError = state => state.error;
export const getPending = state => state.pending;
export const getLoaded = state => state.loaded;
